import FuelTradingTopTicker2 from 'src/components/fuel-trading/top-ticker2'
import FuelTradingTopTickerOrders from 'src/components/fuel-trading/top-ticker-orders'

import * as React from 'react'
import { useState } from 'react'
import { useQuery } from '@tanstack/react-query'
import axios, { AxiosResponse } from 'axios'
import { IAuction } from 'src/_models/auction.model'
import AuctionCard from 'src/components/auction/auction-card'
import {
  Pagination,
  PaginationContent,
  PaginationItem,
  PaginationLink,
  PaginationNext,
  PaginationPrevious,
} from 'src/components/ui/pagination'
import AuctionFilterBtn from 'src/components/auction/auction-filter-btn'
import { useSearchParams } from 'react-router-dom'

const MyWatchlistPage = () => {
  const [page, setPage] = useState(1)
  const [searchParams, _] = useSearchParams()

  const params = searchParams.toString()

  const myWatchlist = useQuery({
    queryKey: ['my-watchlist', `page-${page}`, 'auctions', params],
    queryFn: () => {
      const token = localStorage.getItem('token')
      return axios.get(`/api/wishlist?${params}&page=${page}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }) as Promise<AxiosResponse<{ auctions: IAuction[]; totalPages: number }>>
    },
    cacheTime: 60,
  })

  return (
    <>
      {/* <FuelTradingTopTicker2 /> */}
      <FuelTradingTopTickerOrders />

      <section className="w-full">
        <div className="container mx-auto bg-transparent ">
          <div className="mb-[30px] flex w-full justify-between pt-5">
            <h2 className="text-lg font-bold text-secoundary 2xl:text-2xl">My Watchlist</h2>
            <AuctionFilterBtn />
          </div>

          <div className="grid gap-5 md:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5">
            {myWatchlist.data?.data.auctions &&
              myWatchlist.data?.data.auctions.map((auction) => {
                return (
                  <div className="mb-[15px]" key={`my-watchlist-${auction.id}`}>
                    <AuctionCard auction={auction} />
                  </div>
                )
              })}
          </div>
        </div>
      </section>
      {myWatchlist.data && myWatchlist.data.data.totalPages > 1 && (
        <Pagination>
          <PaginationContent>
            <PaginationItem>
              <PaginationPrevious onClick={() => setPage((page) => page - 1)} />
            </PaginationItem>
            {Array.from(Array(myWatchlist.data.data.totalPages), (e, i) => {
              return (
                <PaginationItem key={i}>
                  <PaginationLink onClick={() => setPage(i)}>{i + 1}</PaginationLink>
                </PaginationItem>
              )
            })}
            {/*<PaginationItem>*/}
            {/*  <PaginationEllipsis />*/}
            {/*</PaginationItem>*/}
            <PaginationItem>
              <PaginationNext onClick={() => setPage((page) => page + 1)} />
            </PaginationItem>
          </PaginationContent>
        </Pagination>
      )}
    </>
  )
}

export default MyWatchlistPage
